import { fontFamily } from 'tailwindcss/defaultTheme';
import { tailwindColorsPalette } from './color';
const tailwind = {
    important: true,
    content: ['./src/**/*.{js,ts,jsx,tsx,mdx}'],
    theme: {
        container: {
            center: true,
        },
        extend: {
            colors: {
                ...tailwindColorsPalette,
            },
            fontFamily: {
                inter: ['Inter', ...fontFamily.sans],
            },
            fontSize: {
                xxs: ['0.625rem', { lineHeight: '1rem' }],
            },
        },
    },
    plugins: [],
};
export default tailwind;
